import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-10 px-4 md:px-8 relative" data-id="element-148">
      <div className="max-w-4xl mx-auto text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#0f1628]/50 to-[#0a0e1a]/50 border border-slate-600/30 rounded-3xl p-8 md:p-16 shadow-2xl" data-id="element-150">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-151">
            40% más rápido
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed" data-id="element-152">
            Un cerebro que duerme 8 horas de calidad procesa la información un
            40% más rápido y regula las hormonas del hambre de forma automática.
          </p>
          <div className="h-px w-24 bg-cyan-500/30 mx-auto mb-8" data-id="element-153" />
          <p className="text-lg text-[#b8c4d6] italic" data-id="element-154">
            "Lo que cambia en 7 días no es solo tu energía; es tu capacidad de
            respuesta emocional y tu claridad mental frente a las crisis."
          </p>
        </motion.div>
      </div>
    </section>;
}